import React from 'react';
import { CalendarIcon, UsersIcon, ClipboardCheckIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export const DayOneToPlan = () => {
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-177">
      {/* Background pattern elements */}
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-purple-50 rounded-full opacity-50 -mr-36 -mb-36" data-id="element-178"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-179">
        <div className="text-center mb-16" data-id="element-180">
          <p className="text-primary font-medium mb-2" data-id="element-181">FAST ONBOARDING</p>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-182">
            Your Day 1–14 Plan
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-183">
            Here's exactly what happens in your first 14 days with us.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12" data-id="element-184">
          {/* Day 1-2 */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 relative" data-id="element-185">
            <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-186">
              1
            </div>
            <div className="mb-4 flex justify-center" data-id="element-187">
              <CalendarIcon className="w-12 h-12 text-primary" data-id="element-188" />
            </div>
            <div className="text-center mb-4" data-id="element-189">
              <div className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-190">
                Day 1–2
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-black text-center" data-id="element-191">
              Initial Consultation
            </h3>
            <ul className="space-y-2 text-text-secondary" data-id="element-192">
              <li className="flex items-start" data-id="element-193">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-194"></span>
                <span data-id="element-195">Founder consult</span>
              </li>
              <li className="flex items-start" data-id="element-196">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-197"></span>
                <span data-id="element-198"> Project Goals & constraints alignment</span>
              </li>
              <li className="flex items-start" data-id="element-199">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-200"></span>
                <span data-id="element-201">Tool access setup (Slack/Jira)</span>
              </li>
            </ul>
          </div>
          {/* Day 3-5 */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 relative" data-id="element-202">
            <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-203">
              2
            </div>
            <div className="mb-4 flex justify-center" data-id="element-204">
              <UsersIcon className="w-12 h-12 text-primary" data-id="element-205" />
            </div>
            <div className="text-center mb-4" data-id="element-206">
              <div className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-207">
                Day 3–7
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-black text-center" data-id="element-208">
              Discovery Phase
            </h3>
            <ul className="space-y-2 text-text-secondary" data-id="element-209">
              <li className="flex items-start" data-id="element-210">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-211"></span>
                <span data-id="element-212">User interviews & data analysis</span>
              </li>
              <li className="flex items-start" data-id="element-213">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-214"></span>
                <span data-id="element-215">Draft roadmap creation</span>
              </li>
              <li className="flex items-start" data-id="element-216">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-217"></span>
                <span data-id="element-218">Success metrics definition</span>
              </li>
            </ul>
          </div>
          {/* Day 8-14 */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6 relative" data-id="element-219">
            <div className="absolute -top-4 -left-4 w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg z-20" data-id="element-220">
              3
            </div>
            <div className="mb-4 flex justify-center" data-id="element-221">
              <ClipboardCheckIcon className="w-12 h-12 text-primary" data-id="element-222" />
            </div>
            <div className="text-center mb-4" data-id="element-223">
              <div className="inline-block bg-purple-100 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-224">
                Day 8–14
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-black text-center" data-id="element-225">
              Execution Kickoff
            </h3>
            <ul className="space-y-2 text-text-secondary" data-id="element-226">
              <li className="flex items-start" data-id="element-227">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-228"></span>
                <span data-id="element-229">PRDs/epics development</span>
              </li>
              <li className="flex items-start" data-id="element-230">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-231"></span>
                <span data-id="element-232">Sprint planning</span>
              </li>
              <li className="flex items-start" data-id="element-233">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-234"></span>
                <span data-id="element-235">Engineering & design kickoff</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Onboarding Checklist Card */}
        <div className="max-w-3xl mx-auto bg-purple-50 rounded-xl p-6 border border-purple-100" data-id="element-236">
          <h3 className="text-xl font-bold mb-4 text-black" data-id="element-237">
            Onboarding Checklist
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-238">
            <div data-id="element-239">
              <h4 className="font-semibold mb-3 text-primary" data-id="element-240">Tools We Join</h4>
              <ul className="space-y-2 text-text-secondary" data-id="element-241">
                <li className="flex items-center" data-id="element-242">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-243"></div>
                  <span data-id="element-244">Slack, Teams etc. </span>
                </li>
                <li className="flex items-center" data-id="element-245">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-246"></div>
                  <span data-id="element-247">Jira, Liner etc. </span>
                </li>
                <li className="flex items-center" data-id="element-248">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-249"></div>
                  <span data-id="element-250">AI prototyping tools </span>
                </li>
                <li className="flex items-center" data-id="element-251">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-252"></div>
                  <span data-id="element-253">GitHub</span>
                </li>
              </ul>
            </div>
            <div data-id="element-254">
              <h4 className="font-semibold mb-3 text-primary" data-id="element-255">
                Communication Setup
              </h4>
              <ul className="space-y-2 text-text-secondary" data-id="element-256">
                <li className="flex items-center" data-id="element-257">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-258"></div>
                  <span data-id="element-259">Standing ceremonies</span>
                </li>
                <li className="flex items-center" data-id="element-260">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-261"></div>
                  <span data-id="element-262">Weekly Communication cadence</span>
                </li>
                <li className="flex items-center" data-id="element-263">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-264"></div>
                  <span data-id="element-265">Documentation repositories</span>
                </li>
                <li className="flex items-center" data-id="element-266">
                  <div className="w-1.5 h-1.5 rounded-full bg-primary mr-2" data-id="element-267"></div>
                  <span data-id="element-268">Reporting structure</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <div className="mt-12 text-center" data-id="element-269">
          <Button variant="primary" onClick={openCalendly} className="text-lg px-8 py-4" data-id="element-270">
            Speak with a Senior PM
          </Button>
        </div>
      </div>
    </section>;
};